import Properties from './Properties.js'
import Studio from 'jsreport-studio'

Studio.addPropertiesComponent('browser client', Properties, (entity) => entity.__entitySet === 'templates' && entity.recipe === 'html-with-browser-client')

Studio.addApiSpec({
  template: {
    omitDataFromOutput: false
  }
})



/** WEBPACK FOOTER **
 ** ./studio/main_dev.js
 **/